export default function unique<T>(carry: T[], item: T): T[] {
	if (!carry.includes(item)) {
		carry.push(item)
	}

	return carry
}
